export const APP_SETTINGS = {
  // endpoint: 'http://localhost:5000/',
  // endpoint: "https://tf-shared-functionapp.azurewebsites.net/",
  // public_endpoint: "http://localhost:7071/",
  // endpoint: "https://tf-shared-functionapp.azurewebsites.net/",
  // private_endpoint: "http://localhost:7071/",
  // private_endpoint: "https://ialdrbackend.bsv.capgemini.com/",
  // private_endpoint: "https://fa-ialdr-shared-backend-01.azurewebsites.net/",
  // public_endpoint: "https://fa-ialdr-shared-backend-01.azurewebsites.net/",
  private_endpoint: window.location.origin,
  public_endpoint: window.location.origin,
  // api_id:"doc_translate_DBS",
  // login_endpoint: "https://ldr-auth-poc.azurewebsites.net",
  // login_endpoint: 'http://127.0.0.1:5000',
  // public_endpoint:"https://tf-funappfrontendclient2.azurewebsites.net/",
  // private_endpoint:"https://iapoc.bsv.capgemini.com/"
  // public_endpoint : "https://hdmtest-shared-functionapp-backend.azurewebsites.net/"
  // private_endpoint:"https://sharedfunctionappbackend.azurewebsites.net/",
  // public_endpoint:"https://sharedfunctionappbackend.azurewebsites.net/"
  // private_endpoint: "https://fastapildrbackend.azurewebsites.net/",
  // public_endpoint: "https://fastapildrbackend.azurewebsites.net/",
  // private_endpoint: "https://saintgobain-ialdr.bsv.capgemini.com",
  // public_endpoint: "https://saintgobain-ialdr.bsv.capgemini.com",
};
